import React, { useEffect } from "react";
import "./PrivacyPolicy.css";

const CONTACT_EMAIL = "kugathaj.k@gmail.com";

const PrivacyPolicy = () => {
  useEffect(() => {
    const previousTitle = document.title;

    document.title = "Privacy Policy | Bible Ministries";
    document.documentElement.classList.add("privacy-scroll-lock");
    document.body.classList.add("privacy-scroll-lock");

    return () => {
      document.title = previousTitle;
      document.documentElement.classList.remove("privacy-scroll-lock");
      document.body.classList.remove("privacy-scroll-lock");
    };
  }, []);

  return (
    <main className="privacy-policy-page">
      <article
        className="privacy-policy-container"
        aria-labelledby="privacy-policy-title"
      >
        <header className="privacy-policy-header">
          <div className="privacy-policy-header-content">
            <h1 id="privacy-policy-title">
              Privacy Policy for Bible Ministries
            </h1>
            <p>
              Effective date: <time dateTime="2026-08-25">August 25, 2026</time>
            </p>
          </div>
        </header>

        <div className="privacy-policy-sections">
          <section className="privacy-policy-section">
            <h2>About this Privacy Policy</h2>
            <p>
              Bible Ministries (“we” or “our”) is committed to protecting the
              privacy of everyone who uses the Bible Ministries application.
              This Privacy Policy explains how the app handles information and
              describes our privacy practices.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>Data Collection and Usage</h2>
            <p>
              Bible Ministries does not require users to create an account and
              does not collect, store, sell, rent, or share personal or
              sensitive user data.
            </p>
            <p>
              The app does not use advertising, analytics, tracking, or other
              third-party data-collection tools to monitor its users.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>Information Stored on Your Device</h2>
            <p>
              To provide its features, Bible Ministries may save your selected
              language and downloaded or cached Bible content locally on your
              device. This local information is used only to remember your
              preference, improve loading speed, and make content available
              offline.
            </p>
            <p>
              Locally stored preferences and cached content are not transmitted
              to Bible Ministries and are not used to identify or profile you.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>Third-Party Services and Data Sharing</h2>
            <p>
              Bible Ministries does not integrate third-party advertising,
              analytics, or tracking services that collect, store, or share
              user data. Because we do not collect personal or sensitive user
              data, we do not sell or share such data with other companies or
              organisations.
            </p>
            <p>
              The app may contain links to external websites. If you choose to
              open an external website, that website&apos;s own privacy policy and
              data practices will apply.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>Data Security</h2>
            <p>
              Bible Ministries does not store personal or sensitive user data
              on servers operated by the developer. The app and this website
              use HTTPS to protect information while content is delivered over
              the internet.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>Data Retention and Deletion</h2>
            <p>
              Because Bible Ministries does not collect or store personal or
              sensitive user data, the developer has no such user data to
              retain or delete.
            </p>
            <p>
              You can remove locally stored preferences and cached content at
              any time by clearing the app&apos;s storage or browser data, or by
              uninstalling the app.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>Children&apos;s Privacy</h2>
            <p>
              Bible Ministries does not knowingly collect personal or sensitive
              information from children or from any other users.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy when the app or applicable
              requirements change. The updated policy will be published on this
              page with a revised effective date. Where required, material
              changes will also be communicated through the app or another
              appropriate method.
            </p>
          </section>

          <section className="privacy-policy-section privacy-policy-contact">
            <h2>Contact Us</h2>
            <p>
              Bible Ministries is provided by Kugathaj Kangeswaran. If you have
              questions, concerns, or privacy-related requests, contact us at{" "}
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
            </p>
          </section>
        </div>
      </article>
    </main>
  );
};

export default PrivacyPolicy;
